<template>
    <div>
        <template v-if='item.availability_date'>
            <h4 class='section-heading'>{{ $t(availability_heading)}}</h4>
            <div v-if="this.item.availability_date" class="pb-2 form-group">
                <table class='availability table'>
                    <thead class="thead-light">
                        <tr>
                            <th style="min-width:100px;width:130px;">{{ $t('translations.day_of_week')}}</th>
                            <th style="min-width:225px;width:230px;">{{ $t('translations.availability')}}</th>
                            <th v-if='Array.isArray(sites)' style="min-width:100px;">{{ $t('translations.site')}}</th>
                            <th v-if='show_capacity' style="min-width:100px;width:100px;">{{ autobrand('translations.capacity_requests')}}</th>
                            <th style="min-width:100px;width:100px;">&nbsp;</th>
                        </tr>
                    </thead>
                    <template v-for="(day, day_of_week) in $root.lookup.dayNames">
                        <tr :key='day_of_week' class='day_heading'>
                            <td :colspan='colspan'>{{ day | capitalise}}</td>
                            <td>
                                <button v-on:click.prevent='addDayAvailability(day_of_week)' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button>
                            </td>
                        </tr>
                        <template v-if='getAvailabilityIndexes(item.availability_date, day_of_week).length'>
                            <template v-for='(date_index) in getAvailabilityIndexes(item.availability_date, day_of_week)'>
                                <template v-if='!Array.isArray(sites) || item.availability_date[date_index].availability_time.filter(obj => {return site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length'>
                                    <template v-for='(time, index) in item.availability_date[date_index].availability_time'>
                                        <tr v-if='is_network_admin() || !Array.isArray(sites) || site.find(site => {return site.id == time.site_id})' :key='item.availability_date[date_index].id + "-" + index' class='day_value'>
                                            <td>&nbsp;</td>
                                            <td :key='"time-" + item.availability_date[date_index].id + "-" + index'>
                                                <ul class="availability-time">
                                                    <li :key='item.availability_date[date_index].id + "-" + index'>
                                                        <input class="form-control-inline" type='time' :name='item.availability_date[date_index].date_from + "-" + index + "-from"' v-model="item.availability_date[date_index].availability_time[index].from">
                                                        -
                                                        <input class="form-control-inline" type='time' :name='item.availability_date[date_index].date_from + "-" + index + "-to"' v-model="item.availability_date[date_index].availability_time[index].to">
                                                    </li>
                                                </ul>
                                            </td>
                                            <td v-if='Array.isArray(sites)' :key='"site-" + item.availability_date[date_index].id + "-" + index'>
                                                <select class="form-control-inline" v-model="item.availability_date[date_index].availability_time[index].site_id">
                                                    <option :key='item.availability_date[date_index].id + "-" + index + "-" + site.id' v-for="site in sites" v-bind:value="site.id">
                                                        {{ site.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td v-if='show_capacity' :key='"capacity-" + item.availability_date[date_index].id + "-" + index'>
                                                <input class="form-control-inline input-capacity" type="number" min="0" v-model='item.availability_date[date_index].availability_time[index].capacity'>
                                            </td>
                                            <td>
                                                <button v-on:click.prevent='deleteDayAvailability(date_index, index)' class="btn btn-danger btn-sm btn-round btn-block">{{ $t('translations.remove')}}</button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <template v-else>
                                    <tr :key='item.availability_date[date_index].id + "-none"'>
                                        <td :colspan='colspan'>{{ $t('translations.no_availability')}}</td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <tr :key='day + "-none"'>
                                <td :colspan='colspan'>{{ $t('translations.no_availability')}}</td>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
            <p v-else>
                {{ $t('translations.no_standard_availability')}}
            </p>
            <h4 class='section-heading'>{{ $t(exceptions_heading)}}</h4>
            <div class="pb-2 form-group">
                <p class='alert alert-info'>
                    {{ $t(`${exception_help_prefix}_part1`)}}
                    <span class='text-nowrap'>9:00 - 12:00</span>.
                    {{ $t(`${exception_help_prefix}_part2`)}}
                    <span class='text-nowrap'>9:00 - 11:00</span>
                    {{ $t(`${exception_help_prefix}_part3`)}}
                    <span class='text-nowrap'>14:00 - 17:00.</span>
                    {{ $t(`${exception_help_prefix}_part4`)}}
                </p>
                <table class='availability table'>
                    <thead class="thead-light">
                        <tr>
                            <th>{{ $t('translations.start_date')}}</th>
                            <th>{{ $t('translations.end_date')}}</th>
                            <th>{{ $t('translations.availability')}}</th>
                            <th v-if='Array.isArray(sites)' >{{ $t('translations.site')}}</th>
                            <th v-if='show_capacity' >{{ autobrand('translations.capacity_requests')}}</th>

                            <th style='width: 15%'>
                                <button v-on:click.prevent='addAvailability()' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button>
                            </th>
                        </tr>
                    </thead>
                    <template v-if='getAvailabilityExceptionIndexes(item.availability_date).length'>
                        <template v-for='(date_index) in getAvailabilityExceptionIndexes(item.availability_date)'>
                            <tr v-if='!Array.isArray(sites) || item.availability_date[date_index].availability_time.filter(obj => {return $root.provider.site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length' :key='item.availability_date[date_index].id + "-" + date_index' class='day_value'>
                                <td>
                                    <!-- <datetime2 value-zone='local' placeholder='DD/MM/YYYY' type='date' format='dd/MM/yyyy' auto v-model="item.availability_date[date_index].date_from"></datetime2> -->
                                    <!-- <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class='form-control-inline' type='date' v-model='item.availability_date[date_index].date_from'></b-form-datepicker> -->
                                    <input class='form-control-inline' type='date' v-model='item.availability_date[date_index].date_from'>
                                </td>
                                <td>
                                    <!-- <datetime value-zone='local' placeholder='DD/MM/YYYY' type='date' format='dd/MM/yyyy' auto v-model="item.availability_date[date_index].date_to"></datetime> -->
                                    <input class='form-control-inline' type='date' v-model='item.availability_date[date_index].date_to'>
                                </td>
                                <td>
                                    <ul>
                                        <template v-for='(time, index) in item.availability_date[date_index].availability_time'>
                                            <li :key='item.availability_date[date_index].id + "-" + index'>
                                                <div class="d-flex">
                                                    <input class='form-control-inline' type='time' :name='item.availability_date[date_index].date_from + "-" + index + "-from"' v-model="item.availability_date[date_index].availability_time[index].from">
                                                    <div class='pl-2 pr-2'>-</div>
                                                    <input class='form-control-inline' type='time' :name='item.availability_date[date_index].date_from + "-" + index + "-to"' v-model="item.availability_date[date_index].availability_time[index].to">
                                                </div>
                                            </li>
                                        </template>
                                    </ul>
                                </td>
                                <td v-if='Array.isArray(sites)' >
                                    <select class='form-control-inline' v-model="item.availability_date[date_index].availability_time[0].site_id">
                                        <option :key='date_index + "-" + site.id' v-for="site in sites" v-bind:value="site.id">
                                            {{ site.name }}
                                        </option>
                                    </select>
                                </td>
                                <td v-if='show_capacity'>
                                    <input class='form-control-inline input-capacity' type="number" min="0" v-model='item.availability_date[date_index].availability_time[0].capacity'>
                                </td>

                                <td>
                                    <button v-on:click.prevent='deleteAvailability(date_index)' class="btn btn-danger btn-sm btn-round btn-block">Remove</button>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <template v-else>
                        <tr key="exceptions-none">
                            <td :colspan='colspan'>{{$t('translations.no_availibility_exceptions_found')}}</td>
                        </tr>
                    </template>
                </table>
            </div>
        </template>
    </div>
</template>

<script>
	export default {
		props: {
            availability_heading: {
                default: "translations.availability"
            },
            exceptions_heading: {
                default: "translations.availability_exceptions"
            },
            exception_help_prefix: {
                default: "translations.alert_info_generic_availability"
            },
            item: {
                default: () => {
                    return {
                        availability_date: [],
                    }
                }
            },
            provider_id: {

            },
            sites: {
                default: null
            },
            show_capacity: {
                default: false
            }
		},
		data: function(){
			return {
			};
		},
        computed: {
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            colspan() {
                let colspan = 4;

                if(!this.sites) {
                    colspan--;
                }
                if(!this.show_capacity) {
                    colspan--;
                }

                return colspan;
            }
        },
        watch: {
            
        },
        mounted() {
            
        },

        methods: {
            addAvailability() {
                this.item.availability_date.push({
                    "id":-(this.item.availability_date.length),
                    "date_from":"",
                    "day_of_week": null,
                    "date_to":null,
                    "availability_time": [{
                        capacity:0,
                        from:null,
                        to:null,
                        site_id:this.sites ? this.sites[0].id : null
                    }]
                });
                //this.item.availability.push({"date_from":"","date_to":null});
            },
            addDayAvailability(day_of_week) {
                var availability_date = this.item.availability_date.find(obj => obj.day_of_week == day_of_week);

                if(!availability_date) {
                    availability_date = {
                        id:-(this.item.availability_date.length),
                        date_from: null,
                        day_of_week: day_of_week,
                        date_to: null,
                        "availability_time": []
                    };
                    this.item.availability_date.push(availability_date);
                }
                availability_date.availability_time.push({
                    capacity:0,
                    from:null,
                    to:null,
                    site_id:this.sites ? this.sites[0].id : null
                });
                //this.item.availability.push({"date_from":"","date_to":null});
            },
            deleteAvailability(index) {
                console.log(index);
                console.log(this.item.availability_date);

                this.item.availability_date.splice(index, 1);
                console.log(this.item.availability_date);
            },
            deleteDayAvailability(date_index, time_index) {
                console.log(date_index);
                console.log(time_index);
                console.log(this.item.availability_date[date_index].availability_time);

                this.item.availability_date[date_index].availability_time.splice(time_index, 1);
                console.log(this.item.availability_date[date_index].availability_time);
            },
        }
    }
</script>
